
webpack.register(
    'modules/qualifying-status/qualifying-status',
    function() {
        return import('modules/qualifying-status/qualifying-status');
    },
    true
);